import { useQueryClient, useMutation } from 'react-query';
import axios from 'axios';
import { API_PREFIX_URL, CACHE_KEYS } from './config';

const RULES_CONTROLLER = 'tap_question_rules';

const API = {
  create: async (tapSurveyIdentifier, params) => {
    const createUrl = `${API_PREFIX_URL}/tap_surveys/${tapSurveyIdentifier}/${RULES_CONTROLLER}`;
    return await axios.post(createUrl, params);
  },
  update: async (tapSurveyIdentifier, ruleId, params) => {
    const updateUrl = `${API_PREFIX_URL}/tap_surveys/${tapSurveyIdentifier}/${RULES_CONTROLLER}/${ruleId}`;
    return await axios.patch(updateUrl, params);
  },
  destroy: async (tapSurveyIdentifier, ruleId) => {
    const deleteUrl = `${API_PREFIX_URL}/tap_surveys/${tapSurveyIdentifier}/${RULES_CONTROLLER}/${ruleId}`;
    return await axios.delete(deleteUrl);
  },
};

/*
 *  Create Rule
 */
const addNewRule = async ({ tapSurveyIdentifier, ...rest }) => {
  return await API.create(tapSurveyIdentifier, rest);
};

export const useAddNewRule = () => {
  const queryClient = useQueryClient();
  return useMutation(addNewRule, {
    onSuccess: () => {
      queryClient.invalidateQueries(CACHE_KEYS.RULESETS);
    },
  });
};

/*
 *  Update Rule
 */
const updateRule = async ({ tapSurveyIdentifier, ruleId, ...rest }) => {
  return await API.update(tapSurveyIdentifier, ruleId, rest);
};

export const useUpdateRule = () => {
  const queryClient = useQueryClient();
  return useMutation(updateRule, {
    onSuccess: () => {
      queryClient.invalidateQueries(CACHE_KEYS.RULESETS);
    },
  });
};

/*
 *  Delete Rule
 */
const deleteRule = async ({ tapSurveyIdentifier, ruleId }) => {
  return await API.destroy(tapSurveyIdentifier, ruleId);
};

export const useDeleteRule = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteRule, {
    onSuccess: () => {
      queryClient.invalidateQueries(CACHE_KEYS.RULESETS);
    },
  });
};
